import { Component, input } from '@angular/core';
import { Avatar } from 'primeng/avatar';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-upload-heading',
  imports: [Avatar, TranslatePipe],
  templateUrl: './upload-heading.component.html',
  styleUrl: './upload-heading.component.scss',
})
export class UploadHeadingComponent {
  label = input.required<string>();
  translationPrefix = input.required<string>();
}
